import axios from "axios";
import * as mock from "../mockup/mockup";
import {
  browserName,
  fullBrowserVersion,
  isEdge,
  isOpera,
  isSafari,
  isFirefox,
  isChrome
} from "react-device-detect";
import { sendCustomProfileReport } from "../../utils/reporting/customReporting";
import { apiEndPoint, fastLoginSessionKillUrl } from "../../statics/config";
import { apiEndPointConstant } from "../../statics/constants";
import { axiosInstance } from "../config/configApi";
import { normalizeApiText } from "../../utils/charset";
import { normalizeProfileLanguage } from "../../utils/profileLanguage";

let terminalOsType = null;
switch (true) {
  case isChrome:
    terminalOsType = 9;
    break;
  case isSafari:
    terminalOsType = 10;
    break;
  case isEdge:
    terminalOsType = 11;
    break;
  case isFirefox:
    terminalOsType = 12;
    break;
  case isOpera:
    terminalOsType = 13;
    break;
  default:
    terminalOsType = 0;

    break;
}

/**
 * Heal names that were persisted mangled before the transport was pinned to
 * UTF-8, so state, context and localStorage all end up holding real text.
 * A no-op for names that are already correct.
 */
const normalizeProfileNames = (response) => {
  const profiles = response && response.data;
  if (Array.isArray(profiles)) {
    profiles.forEach((profile) => {
      if (profile && typeof profile.name === "string") {
        profile.name = normalizeApiText(profile.name);
      }
    });
  }
  return response;
};

const getProfilesApi = async () => {
  return normalizeProfileNames(
    await axiosInstance.get(apiEndPointConstant.client + "/profiles")
  );
};

const getProfileAvatarsApi = async () => {
  return await axiosInstance.get("/resources/avatars");
};

const addProfile = async (name, isKid, pin, posterName) => {
  return await axios.post(apiEndPointConstant.client + "/profiles", {
    name: name,
    kid: isKid,
    pin: pin,
    posterName: posterName
  });
};

const deleteProfile = async (id) => {
  return await axios.delete(apiEndPointConstant.client + "/profiles/" + id);
};

const updateProfile = async (id, name, pin, posterName, isKid, options = {}) => {
  return await axios.put(apiEndPointConstant.client + "/profiles", {
    id: id,
    name: name,
    pin: options.removePin ? "" : pin || undefined,
    currentPinCode: options.currentPin,
    posterName: posterName,
    kid: isKid
  });
};

const loginWithProfile = async (id, pin) => {
  const response = await axiosInstance.post(
    apiEndPointConstant.client + "/profiles/select",
    {
      id: id,
      pin: pin
    }
  );
  // Profile selection issues a new token with the selected profile's claims.
  // Store it before the caller restores analytics identity or fetches content.
  const token = response.data?.access_token;
  if (typeof token === "string" && token.trim()) {
    localStorage.setItem("userToken", `Bearer ${token.trim().replace(/^Bearer\s+/i, "")}`);
  }
  return response;
};

const checkProfilePin = async (id, pin) => {
  return await axiosInstance.post(
    apiEndPointConstant.client + "/profiles/validate/pin/" + id,
    pin,
    {
      headers: {
        "Content-Type": "text/plain"
      }
    }
  );
};

const modifyProfile = async (
  profileCode,
  userLevel,
  nickName,
  photo,
  password,
  profileRoleId,
  isRemovePassword
) => {
  return await axios.post(apiEndPointConstant.authClient + "/");
};

const setUserMediaServices = async (apiEndpoint, type, sessiondId) => {
  return await axios.post(
    `${apiEndpoint}/sdk_setusermediaservices.jsp`,
    `mediaservices=${type}`
  );
};

const setUserLanguage = async (apiEndpoint, sessiondId, language) => {
  const code = normalizeProfileLanguage(language);
  if (!code) throw new Error("Unsupported profile language.");
  const preference = code === "AR" ? "Arabic" : "English";
  return await axiosInstance.post(
    `/client/interact/language?preference=${preference}`
  );
};

const getUserLanguage = async () => {
  const response = await axiosInstance.get(`/client/interact/language`);
  const code = normalizeProfileLanguage(response.data?.language);
  return {
    ...response,
    data: { ...response.data, language: code === "AR" ? "Arabic" : "English" }
  };
};

const setPlayInitialInfo = async () => {
  var apiEndpoint = localStorage.getItem("interfaceurl");
  var sessiondId = localStorage.getItem("sessionid");
  return await axios.post(
    `${apiEndpoint}/sdk_getplayinitialinfo.jsp`,
    `ostype=${browserName}&osversion=${fullBrowserVersion}`
  );
};

const changeProfileParentalLevel = async (profileCode, userLevel) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.post(
    `${apiUrl}/sdk_modifyprofile.jsp`,
    `profilecode=${profileCode}&limitlevel=${userLevel}`
  );
};

// Read the saved server policy rather than an optional legacy profile field.
const getParentalLevel = async () => {
  const response = await axios.get("/client/interact/majurity");
  const level = String(response.data);
  if (!["G", "7", "13", "18"].includes(level)) throw new Error("Parental policy unavailable");
  return { ...response, data: level };
};

const parentalControlApi = async (preferenceValue, pinCode, profileId) => {
  const response = await axios.post(
    "/client/interact/majurity?preference=" + encodeURIComponent(preferenceValue),
    { PinCode: pinCode, ProfileUId: profileId }
  );
  if (response.data !== "OK") throw new Error("Parental policy update rejected");
  return response;
};

const getProfileInfo = async (profileCode) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.get(`${apiUrl}/sdk_queryprofile.jsp`, {
    params: {
      profilecode: profileCode
    }
  });
};

const checkProfilePassword = async (profileCode, pinCode) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.post(
    `${apiUrl}/sdk_checkpwdprofile.jsp`,
    `profilecode=${encodeURIComponent(profileCode)}&pwd=${encodeURIComponent(
      pinCode
    )}`
  );
};

const doPaymentTvod = async (
  programType,
  programCode,
  productCode,
  paymentType,
  deviceid
) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.get(`${apiUrl}/sdk_getmpay.jsp`, {
    params: {
      programtype: programType,
      paytype: paymentType,
      productcode: productCode,
      terminaltype: 4,
      programcode: programCode,
      deviceid: deviceid
    }
  });
};

const payWithUserPromoCode = async (
  programType,
  programCode,
  productCode,
  promoCode,
  deviceid
) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.get(`${apiUrl}/sdk_getmpay.jsp`, {
    params: {
      programtype: programType,
      paytype: 23,
      productcode: productCode,
      terminaltype: 4,
      programcode: programCode,
      voucherid: promoCode,
      deviceid: deviceid
    }
  });
};

const getWirecardPayResult = async (mPayGuid) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.get(`${apiUrl}/sdk_getpayresult.jsp`, {
    params: {
      mpay: mPayGuid
    }
  });
};

const doAuth = async (programCode, columnCode, contentType) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.post(
    `${apiUrl}/doauth.jsp`,
    `programcode=${programCode}&columncode=${columnCode}&contenttype=${contentType}`
  );
};

const doUnsubscribe = async (mPay) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  return await axios.get(`${apiUrl}/sdk_unsubscribe.jsp`, {
    params: {
      mpay: mPay
      // purchasetype: 3,
      // productcode: productCode,
      // contenttype: 1,
      // contentcode: contentCode,
      // action: 4,
      // columncode: columnCode
    }
  });
};

const getUserInitialInfo = async () => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");
  return await axios.get(
    `${apiUrl}/sdk_getinitialuserinfo.jsp${sessionID ? `` : ""}`
  );
};

const getProfileInitialData = async () => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");
  return await axios.get(`${apiUrl}/sdk_getprofileinitdata.jsp`);
};

const getUserPurchaseHistory = async () => {
  return await axios.get("/client/rentpurchase/purchaseHistory");
  // var sessionID = localStorage.getItem("sessionid");
  // var apiUrl = localStorage.getItem("interfaceurl");
  // return await axios.get(`${apiUrl}/sdk_getorderandconsumelist.jsp`, {
  //   params: {
  //     pageno: 1,
  //     numperpage: 500,
  //     producttype: "2,3,5,7"
  //   }
  // });
};

const callLogout = async (usercode) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");

  if (!apiUrl) {
    throw new Error("No interfaceurl found in localStorage");
  }

  apiUrl = apiUrl.slice(0, apiUrl.lastIndexOf("/"));
  let userCode = window.EncryptUtils.dencryptStr(decodeURIComponent(usercode));

  return await axios.get(`${apiUrl}/datasource/mobilelogin.jsp`, {
    params: {
      UserID: userCode,
      Action: "Logout",
      TerminalFlag: 4,
      TerminalOsType: terminalOsType
    }
  });
};

const callMobileConnectLogoutApi = async () => {
  let testUrl =
    "https://test-kolaygiris.turktelekom.com.tr/kolaygiris/mcLogout?client_id=tivibuweb";
  return await axios.get(`${testUrl}/kolaygiris/mcLogout`, {
    params: { client_id: "tivibuweb" },
    headers: { "Content-Type": "text/plain" }
  });
};

const callTokenLogout = async (refreshToken) => {
  return await axiosInstance.post(
    apiEndPointConstant.authClient + "/user/logout",
    {
      refreshToken: refreshToken
    }
  );
};

export {
  setUserMediaServices,
  setUserLanguage,
  getUserLanguage,
  payWithUserPromoCode,
  getProfilesApi,
  getProfileAvatarsApi,
  loginWithProfile,
  checkProfilePin,
  checkProfilePassword,
  addProfile,
  doPaymentTvod,
  setPlayInitialInfo,
  deleteProfile,
  updateProfile,
  getProfileInfo,
  getWirecardPayResult,
  getUserInitialInfo,
  doAuth,
  doUnsubscribe,
  callLogout,
  modifyProfile,
  getUserPurchaseHistory,
  getProfileInitialData,
  changeProfileParentalLevel,
  parentalControlApi,
  getParentalLevel,
  callMobileConnectLogoutApi,
  callTokenLogout
};

// Proof remains in this request chain; never persist the account password or reset token.
export const createPinResetProof = async (profileId, password) => {
  const response = await axiosInstance.post("/parental-controls/pin-reset-proof", { ProfileUId: profileId, Password: password });
  if (response.data?.IsSucceeded !== true || !response.data?.Data?.PinResetProof) throw new Error("PIN reset proof rejected");
  return response.data.Data.PinResetProof;
};
export const resetProfilePin = async (profileId, pin, proof) => {
  const response = await axiosInstance.post("/parental-controls/reset-pin", { ProfileUId: profileId, NewPinCode: pin, PinResetProof: proof });
  if (response.data?.IsSucceeded !== true) throw new Error("PIN reset rejected");
  return response;
};
